import React from "react";

interface ListItemProps {
  label?: string;
  children?: React.ReactNode;
}

export default function ListItem({ label, children }: ListItemProps) {
  return (
    <div className="flex justify-between items-center">
      <p className="text-white text-opacity-50">{label}</p>
      <div className="text-white flex items-center gap-1">{children}</div>
    </div>
  );
}
